const KEY = "notiz.supportContext";

/** sessionStorage on purpose: survives a reload in the same tab, never a new tab or login. */
export function loadSupportContext() {
  try {
    const raw = window.sessionStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && parsed._id ? parsed : null;
  } catch (e) {
    return null;
  }
}

export function saveSupportContext(org) {
  try {
    if (org) window.sessionStorage.setItem(KEY, JSON.stringify(org));
    else window.sessionStorage.removeItem(KEY);
  } catch (e) {
    // storage blocked — context still lives in Redux for this page load
  }
}
